<template>
    <div >
        <section class="categories">
            <div class="container container-tight accordion" id="testAC">
                <div class="categories-content-row">
                    <!-- <div > -->
                        <!-- <transition-group 
                            enter-active-class="fadeIn"
                            tag="div" 
                            class="categories-content accordion" 
                            id="accordion"  
                            data-parent="#testAC"> -->
                            <div id="accordion" data-parent="#testAC">
                                <Question v-for="question in questions" :key="question.post_title" :question="question"></Question>
                            </div>
                        <!-- </transition-group> -->
                    <!-- </div> -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Question from "./Question"

export default {
    data: () => {
        return {
            
        }
    },
    props: ['questions'],
    components: {
        Question
    },
}
</script>
<style scoped>
.categories {
    padding: 0 0 0 0;
}
.categories-content {
    display: block;
}
.cat-block-pr:first-child {
    padding-top: 10px;
}
</style>